<app-dialog
  *ngIf="clientName"
  [dialogType]="dialogType"
  [hideCloseButton]="true"
  [preventCloseOnEsc]="true"
  [stackActions]="true"
  [headerLabel]="
    'DOCUMENT.' + documentType + '.UPDATE_CLIENT_EMAIL_DIALOG.TITLE'
      | uppercase
      | translate
  "
  [primaryActionText]="
    'DOCUMENT.' + documentType + '.UPDATE_CLIENT_EMAIL_DIALOG.UPDATE_AND_SEND'
      | uppercase
      | translate
  "
  [secondaryActionText]="
    'DOCUMENT.' + documentType + '.UPDATE_CLIENT_EMAIL_DIALOG.SEND'
      | uppercase
      | translate
  "
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="primaryActionTrackingAction"
  [secondaryActionTapped]="secondaryActionTrackingAction"
>
  <div id="update-client-email-dialog">
    <p
      class="prompt"
      [innerHTML]="
        'DOCUMENT.' + documentType + '.UPDATE_CLIENT_EMAIL_DIALOG.PROMPT'
          | uppercase
          | translate: { clientName: clientName }
          | safe: 'html'
      "
    ></p>
  </div>
</app-dialog>
